<template>
	<div class="index">
		<van-nav-bar
			left-text="删人提醒"
			left-arrow
			@click-left="back"
		/>
		<div class="content" style="margin-bottom: var(--base-px-60)">

			<div v-for="(i,is) in list" :key="is" class="list">
				<img style="margin-top: -5px;" :src="i.avatar">
				<div style="    position: relative;
    border-bottom: var(--base-px-1) solid #eee;
    padding-bottom: var(--base-px-12);">
					<div style="color: #444;
    font-size: var(--base-px-14);">{{ i.name }}
					</div>
					<div style="color: #9b9b9b;">删除时间：{{ i.createTime }}</div>
					<span @click="seeContactDetail(i)">查看客戶</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {deleteContact} from '../../api/lostCustomers'
import {openUserProfile} from '@/utils/wxCodeAuth'

export default {
	data() {
		return {
			finished: true,
			list: []
		}
	},
	watch: {},
	created() {
		this.getData()
	},
	methods: {
		back() {
			this.$router.back()
		},
		seeContactDetail(data) {
			openUserProfile(2, data.wxExternalUserid)
		},
		getData() {
			deleteContact().then(res => {
				this.list = res.data
			})
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar__content {
	background: #2b63cd;
	color: #fff;
}

/deep/ .van-nav-bar .van-icon {
	color: #fff;
}

/deep/ .van-nav-bar__text {
	color: #fff;
}

/deep/ .van-nav-bar__title {
	color: #fff;
}

/deep/ .van-tabs__line {
	bottom: var(--base-px-9);
	margin-top: 0;
}

/deep/ .van-tabs__nav--line {
	padding-bottom: var(--base-px-1);
}

/deep/ .van-tab__text {
	margin-bottom: var(--base-px-10);
}

/deep/ .van-tab {
	background: #ffffff;
}

/deep/ .van-tabs__nav {
	background: #F1f2f5;
}

/deep/ .van-empty__image img {
	object-fit: contain;
}

/deep/ .van-dropdown-menu__bar {
	height: var(--base-px-36);
}

/deep/ .van-ellipsis {
	font-size: var(--base-px-13);
}

/deep/ .van-action-sheet__description {
	font-size: var(--base-px-16);
	color: #444;
}

/deep/ .tabs .van-cell__title {
	width: var(--base-px-56) !important;
	flex: none !important;
	white-space: nowrap;
}

.index {
	font-size: var(--base-px-14);
	height: 100%;
	background: #fff;

	p {
		margin: 0 !important;
	}

	.fs17 {
		font-size: var(--base-px-14);
	}

	.fs13 {
		font-size: var(--base-px-12);
	}

	.fs14 {
		font-size: var(--base-px-14);
	}

	.header-tool {
		padding: 0 var(--base-px-18);
		height: var(--base-px-40);
		display: flex;
		-webkit-box-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		align-items: center;
		background-color: #fff;

		.clickable {
			font-size: var(--base-px-12);
		}

		.title {
			font-size: var(--base-px-14);
			margin: 0 !important;
		}

		.select-all {
			font-size: var(--base-px-12);
			color: #1890ff;
		}
	}

	.content {
		background: #fff;
		min-height: 92%;

		img {
			width: var(--base-px-22);
			height: var(--base-px-22);
		}

		.list {
			background: #fff;
			padding: var(--base-px-10) var(--base-px-14);
			display: flex;
			align-items: center;
			justify-content: space-between;

			img {
				width: var(--base-px-48);
				height: var(--base-px-48);
			}

			div {
				flex: 1;
				margin-left: var(--base-px-5);
				display: flex;
				/* align-items: center; */
				flex-direction: column;
				justify-content: space-between;

				span {
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
					background: #ebf7ff;
					border: var(--base-px-1) solid #daedff;
					color: #0091ff;
					padding: var(--base-px-1) var(--base-px-2);
				}
			}
		}
	}
}
</style>
